import { render } from "./SwiperBanner.vue?vue&type=template&id=0da865e2&scoped=true&ts=true"
import script from "./SwiperBanner.vue?vue&type=script&lang=ts"
export * from "./SwiperBanner.vue?vue&type=script&lang=ts"

import "./SwiperBanner.vue?vue&type=style&index=0&id=0da865e2&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da865e2"]])

export default __exports__